import { ColDef, ValueGetterParams } from 'ag-grid-community';
import {
  ColSize,
  createDateHasAllTimeCol,
  createDetailButtonColV2,
  createIdCol,
  createPhoneCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';
import TableRowStatusBadge from '@/components/molecule/TableRowStatusBadge';

export const administratorListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '등록 일시',
  }),
  createTypoCol({
    field: 'aId',
    size: 'lg',
    headerName: '아이디 (Email)',
  }),
  createTypoCol({
    field: 'name',
    size: 'sm',
    headerName: '이름',
  }),
  createTypoCol({
    field: 'department',
    size: 'sm',
    headerName: '소속',
  }),
  createPhoneCol({
    field: 'phone',
    size: 'sm',
    headerName: '핸드폰 번호',
  }),
  {
    headerClass: 'ag-right-aligned-cell',
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    field: 'isActivated',
    ...ColSize.xs,
    cellRenderer: (params: ValueGetterParams) => {
      return (
        <TableRowStatusBadge
          type="isActivated"
          value={!!params?.data?.account?.isActivated}
        />
      );
    },
    headerName: '사용 여부',
  },
  createDetailButtonColV2(onDetailClick),
];
